import styled from 'styled-components'

export const EditableTitle = styled.input`
    width: calc(100% - 14px - 4px);
    min-width: 18px;
    max-width: calc(100% - 14px - 4px);
    height: 16px;
    background: var(--gray-200);
    outline: none;
    font-family: var(--font-semibold);
    padding: 0;
    margin: 0;
    margin-top: 1px;
    border: 1px solid transparent;
    border-right: 0;
    border-left: 0;

    &.has-error {
        border-bottom-color: var(--red-500);
    }

    :focus {
        border-bottom-color: var(--blue-500);
    }
`

export const TopBarStyledContainer = styled.div<{ titleItemsCount: number }>`
    background: var(--gray-200);
    height: 40px;

    .delete-alarm-group {
        width: 80px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 16px;
        color: ${({ theme }) => theme['red-700']};
        &.disabled {
            color: ${({ theme }) => theme['gray-700']};
        }
        cursor: pointer;
        &.disabled {
            cursor: not-allowed;
        }

        span {
            font-weight: 600;
            margin-right: 8px;
            font-size: 13px;
        }
    }

    > div.container {
        height: 40px;
        position: relative;

        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        /* gap: 8px; */

        > .title-items {
            position: relative;
            width: calc(100% - 16px - 30px - 80px);
            display: flex;
            flex-wrap: nowrap;
            flex-direction: row;
            gap: 8px;
            margin: 0;

            > .separator {
                margin-top: 10px;
                height: 20px;
                border-left: 1px solid var(--gray-400);
            }
        }

        > button {
            color: var(--gray-0);
            font-family: var(--font-bold);
            font-size: 13px;
            border-radius: 3px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5px;
            height: 30px;
            margin-top: 5px;

            &.settings-back {
                border: none;
                width: 30px;
                margin-right: 8px;
            }

            &.save-button {
                margin-left: auto;
                min-width: 50px;
                max-width: 80px;
            }

            &:focus {
                outline: none;
            }
        }
    }
`

export const TopBarItemStyled = styled.div<{ percentageWidth: string }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-direction: row;
    font-size: 14px;
    color: var(--gray-700);
    width: min-content;
    max-width: ${({ percentageWidth }) => percentageWidth};

    > .text {
        line-height: 16px;
        min-width: 8px;
        white-space: nowrap;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    label {
        padding: 0;
        margin: 0;
        line-height: 13px;

        i {
            color: var(--blue-500);
            cursor: pointer;
        }
    }
`
